// src/paginas/catalogos/familia_eco_pop.tsx

import { Button, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// ✅ CORREÇÃO: Caminhos de importação do CSS atualizados (sem /esm/)
import 'react-pdf/dist/esm/Page/AnnotationLayer';
import 'react-pdf/dist/esm/Page/TextLayer';

// Configuração do worker do PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export default function CatalogoFamiliaEcoPopPage() {
    const [numPages, setNumPages] = useState<number | null>(null);

    function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
        setNumPages(numPages);
    }

    const pdfUrl = '/pdf/CatalogoFamiliaEcoPop.pdf';

    return (
        <div className="container" style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0px 20px 80px 20px',
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%'
            }}>
                <div style={{ paddingBottom: '20px', textAlign: 'left', width: '100%' }}>
                    <Title level={1} style={{ fontSize: '36px', marginBottom: '30px' }}>
                        Catálogo Eco Pop
                    </Title>
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={() => {
                            const link = document.createElement('a');
                            link.href = pdfUrl;
                            link.download = 'CatalogoFamiliaEcoPop.pdf';
                            link.target = '_blank';
                            link.click();
                        }}
                        title='Baixar Catalogo(Pdf)'
                        style={{
                            backgroundColor: '#fff',
                            borderColor: '#0047AB',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '10px 20px',
                            color: '#000'
                        }}
                    >
                        Download
                    </Button>
                </div>

                <div style={{
                    width: '100%',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    overflow: 'hidden'
                }}>
                    <Document
                        file={pdfUrl}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={console.error}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                        {numPages && Array.from(new Array(numPages), (el, index) => (
                           <div key={`page_container_${index + 1}`} style={{ marginBottom: index + 1 < numPages ? '15px' : '0' }}>
                                <Page
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                    width={1158}
                                />
                           </div>
                        ))}
                    </Document>
                </div>
            </div>
        </div>
    );
}